// extracted by mini-css-extract-plugin
module.exports = {"dialog":"dialog_dialog__CBg8T","title":"dialog_title__dEh6B","message":"dialog_message__aSgxd"};